import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { Session } from '../services/session';
import { IResponseCompany } from '@services/company.interface';

export interface IBetaFeatureAccessGuard {
  name: keyof IResponseCompany;
  redirectTo: string;
  enabledWhenFalse?: boolean;
}

@Injectable()
export class BetaFeatureAccessGuard {
  constructor(private router: Router, @Inject(Session) private session) { }

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const config: any = route.data.betaFeatureAccessGuard;

    if (Array.isArray(config)) {
      const navigationConfig: IBetaFeatureAccessGuard = this.checkForMultipleFeatures(config);
      if (navigationConfig) {
        this.router.navigate([navigationConfig.redirectTo]);
        return false;
      }
      return true;
    }

    const redirectTo: string = config.redirectTo || '';
    const isUpsellRoute: boolean = !!config.isUpsellRoute;

    if (this.isBetaFeatureAllowed(config)) {
      // restrict upsell route if company feature is enabled
      if (isUpsellRoute) {
        this.router.navigate([redirectTo]);
        return false;
      }
      return true;
    } else {
      // allow upsell route if company lacks a feature
      if (isUpsellRoute) return true;
      this.router.navigate([redirectTo]);
      return false;
    }
  }

  private checkForMultipleFeatures(config: IBetaFeatureAccessGuard[]): IBetaFeatureAccessGuard {
    return config.find(
      feature => this.isBetaFeatureAllowed(feature) === false,
    );
  }

  private isBetaFeatureAllowed(config: IBetaFeatureAccessGuard): boolean {
    return config.enabledWhenFalse ?
      !this.session.getCompanyProperty(config.name) :
      this.session.getCompanyProperty(config.name);
  }
}
